import { render, staticRenderFns } from "./Giveaway.vue?vue&type=template&id=189f521e&scoped=true&lang=pug&"
import script from "./Giveaway.vue?vue&type=script&lang=js&"
export * from "./Giveaway.vue?vue&type=script&lang=js&"
import style0 from "./Giveaway.vue?vue&type=style&index=0&id=189f521e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189f521e",
  null
  
)

export default component.exports